import * as Yup from 'yup';

import { Box, Typography } from '@mui/material';
import React, { Fragment, useCallback, useMemo, useState } from 'react';

import FormikDialog from '/b2b/common/components/FormikDialog/FormikDialog.component';
import { FormikTextField } from '/b2b/common/components/FormControls/TextField';
import Locale from '/b2b/common/components/Locale';
import PropTypes from 'prop-types';

const EscalateDialog = props => {
    const { open, onClose, onConfirm } = props;
    const [loading, setLoading] = useState(false);

    const initialValues = useMemo(
        () => ({
            subject: '',
            text: '',
        }),
        []
    );

    const validationSchema = useMemo(
        () =>
            Yup.object().shape({
                subject: Yup.string().required().max(50),
                text: Yup.string().required(),
            }),
        []
    );

    const handleSubmit = useCallback(
        async values => {
            setLoading(true);
            try {
                await onConfirm(values);
            } finally {
                setLoading(false);
            }
        },
        [onConfirm]
    );

    return (
        <FormikDialog
            cancelText="common.cancel"
            confirmText="common.save"
            disabled={loading}
            disclaimer="aiAssistant.escalateDialog.disclaimer"
            enableReinitialize
            fullWidth
            initialValues={initialValues}
            loading={loading}
            maxWidth="sm"
            onCancel={onClose}
            onClose={onClose}
            onConfirm={handleSubmit}
            open={open}
            title="aiAssistant.escalateDialog.title"
            validationSchema={validationSchema}
        >
            {() => (
                <Fragment>
                    <Box mb={2}>
                        <Typography variant="body2">
                            <Locale path="aiAssistant.escalateDialog.description" />
                        </Typography>
                    </Box>
                    <Box mb={2}>
                        <FormikTextField
                            fullWidth
                            label="aiAssistant.escalateDialog.subject.label"
                            name="subject"
                            required
                        />
                    </Box>
                    <Box>
                        <FormikTextField
                            fullWidth
                            label="aiAssistant.escalateDialog.text.label"
                            name="text"
                            multiline
                            minRows={4}
                            maxRows={8}
                            required
                        />
                    </Box>
                </Fragment>
            )}
        </FormikDialog>
    );
};

EscalateDialog.propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
};

export default EscalateDialog;
